import Layout from "antd/lib/layout";
import Input from "antd/lib/input";
import styled from "styled-components";
import Row from "antd/lib/row";
import Button from "antd/lib/button";
import config from "../../staticConfig";

const { TextArea } = Input;
const { Content } = Layout;
export const StyledLayout = styled(Layout)`
  margin-top: 24px;
  background-color: #ffffff;
`;
export const StyledContent = styled(Content)`
  min-height: 240px;
  max-width: 757px;
`;
type errorType = {
  error: boolean;
};
export const StyledInput = styled(Input)<errorType>`
  border: none;
  height: 48px;
  max-width: 757px;
  border-radius: 8px 8px 0 0;
  background-color: ${config.themeConfig.mainBackgroundColor};
  color: ${config.themeConfig.buttonBackgroundColor}
  //font-family: "PingFang SC";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  padding-left: 24px !important;
  &:hover, &:focus {
    background-color: ${config.themeConfig.mainBackgroundColor} !important;
  }
  border: ${(props) => (props.error ? "1px solid #ff0000" : "none")}
`;
export const StyledTextArea = styled(TextArea)<errorType>`
  border: none;
  min-height: 195px !important;
  max-width: 757px;
  border-radius: 2px;
  background-color: ${config.themeConfig.noteBodyBackgroundColor} !important;
  color: ${config.themeConfig.buttonBackgroundColor};
  //font-family: "PingFang SC";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  padding-left: 24px !important;
  &:hover,
  &:focus {
    background-color: ${config.themeConfig.noteBodyBackgroundColor} !important;
  }
  border: ${(props) => (props.error ? "1px solid #ff0000" : "none")};
`;

export const StyledSpace = styled.div`
  box-sizing: border-box;
  height: 1px;
  max-width: 757px;
  border: 1px solid rgba(0, 21, 41, 0.24);
`;

export const StyledRow = styled(Row)`
  padding-left: 24px;
  padding-right: 19.5px;
  height: 45px;
  background-color: ${config.themeConfig.noteBodyBackgroundColor};
`;

export const StyledButton = styled(Button)`
  border-radius: 2px;
  background-color: ${config.themeConfig.buttonBackgroundColor};
  color: #ffffff;
  //font-family: "PingFang SC";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
`;
